export default {"src":"/_next/static/media/modern-scale.bcc2644b.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};